import initOneTrustFlow, { initOneTrustFlowWithInjection } from '@ui/one-trust/dist/consent-wiring'

window.consentWiring = initOneTrustFlow
window.initOneTrustFlow = initOneTrustFlowWithInjection
